import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { useStaticQuery, graphql } from 'gatsby';

import { parseContentfulImageItem } from '../../lib/helpers';

import favicon from '../../assets/images/favicon.ico';
import faviconImage from '../../assets/images/favicon.svg';

import mainImage from '../../assets/images/meta/play-with-a-friend-meta.jpg';

const MetaDescription = (props) => {
	const data = useStaticQuery(graphql`
        query SiteTitleQuery {
            site {
                siteMetadata {
                    title
                    description
                }
            }
        }
	`);

	const {
		page = {},
		children,
	} = props;

	const {
		meta,
	} = page;

	const {
		site,
	} = data;

	const defaultImage = {
		src: mainImage,
		height: 630,
		width: 1200,
	};

	const pageTitle = meta?.pageTitle || page.title || site.siteMetadata.title;
	const metaDescription = meta?.metaDescription || page?.excerpt?.excerpt || site.siteMetadata.description;

	const ogTitle = meta?.ogTitle || pageTitle;
	const ogDescription = meta?.ogDescription || metaDescription;

	const twitterTitle = meta?.twitterTitle || ogTitle;
	const twitterDescription = meta?.twitterDescription || ogDescription;

	const ogImage = parseContentfulImageItem(meta?.ogImage, meta?.ogImage ?? defaultImage);
	const twitterImage = parseContentfulImageItem(meta?.twitterImage) || ogImage;

	return (
		<Helmet>
			<html lang="en" dir="ltr" />
			<meta charSet="utf-8" />
			<link rel="shortcut icon" href={favicon} />
			<meta
				name="viewport"
				content="width=device-width, initial-scale=1, shrink-to-fit=no"
			/>
			<meta name="theme-color" content="#000000" />
			<link rel="apple-touch-icon" sizes="180x180" href={faviconImage} />
			<link rel="icon" type="image/png" sizes="32x32" href={faviconImage} />
			<link rel="icon" type="image/png" sizes="16x16" href={faviconImage} />
			<meta name="msapplication-TileColor" content="#da532c" />
			<meta name="theme-color" content="#ffffff" />
			<title>
				{`${pageTitle} - ${site.siteMetadata.title}`}
			</title>
			<meta name="description" content={metaDescription || page.description} />
			<meta name="application-name" content={site.siteMetadata.title} />
			<meta name="application-name" content={pageTitle} />

			{/* Facebook Tags */}
			<meta property="og:site_name" content={pageTitle} />
			<meta property="og:type" content="website'" />
			<meta property="og:title" content={`${ogTitle} - ${site.siteMetadata.title}`} />
			<meta property="og:description" content={ogDescription} />
			<meta property="og:image:width" content={ogImage?.width} />
			<meta property="og:image:height" content={ogImage?.height} />
			<meta property="og:image" content={ogImage?.src} />

			{/* Twitter tags */}
			<meta property="twitter:title" content={`${twitterTitle} - ${site.siteMetadata.title}`} />
			<meta property="twitter:description" content={twitterDescription} />
			<meta name="twitter:image" content={twitterImage?.src} />
			{children}
		</Helmet>
	);
};

MetaDescription.propTypes = {
	page: PropTypes.shape({}).isRequired,
};

export default MetaDescription;
